/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeParagraph, BaSeSmall1, BaSeTheme } from '@base/react';
import { format, parseISO } from 'date-fns';
import React from 'react';

function Message({ message = '', dateInclusion, user }) {
  const [mostrarMensagemCompleta, setMostrarMensagemCompleta] =
    React.useState(false);

  const isBigMessage = message.length > 40;

  const mensagemTruncada = message.slice(0, 30) + ' ... ';

  const returnMessage = React.useCallback(() => {
    return (
      <div>
        <BaSeSmall1>
          {format(parseISO(dateInclusion), 'dd/MM/yyyy - HH:mm')}
        </BaSeSmall1>
        <div>
          <BaSeParagraph>
            <p style={{ color: '#ce6aa4' }}>{`@${user}`}</p>
          </BaSeParagraph>

          {message}
        </div>
      </div>
    );
  }, [dateInclusion, message, user]);

  const returnIfWasBigMessage = React.useCallback(() => {
    return (
      <div>
        <BaSeSmall1>
          {format(parseISO(dateInclusion), 'dd/MM/yyyy - HH:mm')}
        </BaSeSmall1>
        <div>
          <BaSeParagraph>
            <p style={{ color: '#ce6aa4' }}>{`@${user}`}</p>
          </BaSeParagraph>

          {mostrarMensagemCompleta ? (
            <>
              {message}
              <div onClick={() => setMostrarMensagemCompleta(false)}>
                <BaSeParagraph
                  color={BaSeTheme.colors.institucionais.azulSebrae36}
                >
                  Ler menos
                </BaSeParagraph>
              </div>
            </>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {mensagemTruncada}
              <div onClick={() => setMostrarMensagemCompleta(true)}>
                <BaSeParagraph
                  color={BaSeTheme.colors.institucionais.azulSebrae36}
                >
                  Ler mais
                </BaSeParagraph>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }, [dateInclusion, mensagemTruncada, message, mostrarMensagemCompleta, user]);

  return (
    <div>
      <div>
        <div style={{ marginTop: 8 }}>
          {isBigMessage ? returnIfWasBigMessage() : returnMessage()}
        </div>
      </div>
    </div>
  );
}

export default Message;
